/**
 * Auto-registers every document type for the shared viewer.
 *
 * Each file under ./types that exports a `documentDefinition` is wired in
 * automatically (webpack require.context). Adding a new document type on the
 * frontend = create ONE file in ./types that exports its definition. There is
 * no central list to edit here, and capabilities are never redeclared — they
 * come from the backend in the /api/shared response.
 */
import { registerDocument, type FrontendDocumentDefinition } from './registry';

// require.context is provided by webpack (Create React App / craco). It eagerly
// collects every *.tsx under ./types so their definitions self-register.
const ctx = (require as any).context('./types', false, /\.tsx$/);
ctx.keys().forEach((key: string) => {
  const def: FrontendDocumentDefinition | undefined = ctx(key).documentDefinition;
  if (def && def.docType && def.renderer) {
    registerDocument(def);
  }
});
